module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/activos/components/kpis-tabla/kpis-tabla.component.scss
// module id = ./src/app/main/content/activos/components/kpis-tabla/kpis-tabla.component.scss
// module chunks = main